import { z } from 'zod';

export const AutomationTriggerSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('cron'),
        cron: z.string().min(1),
        timezone: z.string().optional().default('UTC'),
    }),
    z.object({
        type: z.literal('event'),
        pattern: z.string().min(1),
        filter: z.record(z.string(), z.unknown()).optional(),
    }),
    z.object({
        type: z.literal('manual'),
    }),
]);

export const AutomationActionSchema = z.object({
    type: z.enum([
        'notify',
        'queue_notification',
        'render_report',
        'survey_dispatch',
        'http_webhook',
        'generate_document',
    ]),
    order: z.number().int().optional().default(0),
    channels: z.array(z.string()).optional(),
    payload: z.record(z.string(), z.unknown()).optional(),
    target: z.record(z.string(), z.unknown()).optional(),
    reportName: z.string().optional(),
    reportFormat: z.enum(['pdf', 'xlsx']).optional(),
    reportParameters: z.record(z.string(), z.unknown()).optional(),
    attachToNextEmail: z.boolean().optional(),
    formTemplateId: z.string().optional(),
    surveyTitle: z.string().optional(),
    surveyDueDate: z.coerce.date().optional().nullable(),
    surveyTarget: z.record(z.string(), z.unknown()).optional(),
    webhookUrl: z.string().url().optional().or(z.literal('')),
    webhookMethod: z.enum(['GET', 'POST']).optional(),
    webhookHeaders: z.record(z.string(), z.string()).optional(),
    webhookBodyTemplate: z.record(z.string(), z.unknown()).optional(),
});

export const CreateAutomationDefinitionSchema = z.object({
    name: z.string().min(1),
    code: z.string().optional(),
    description: z.string().optional(),
    status: z.enum(['active', 'inactive', 'draft']).optional().default('draft'),
    triggers: z.array(AutomationTriggerSchema).default([]),
    actions: z.array(AutomationActionSchema).default([]),
    failurePolicy: z.enum(['stop', 'continue']).optional().default('stop'),
});

export const UpdateAutomationDefinitionSchema = CreateAutomationDefinitionSchema.partial();
